'use client';

import { useTranslation } from '@/contexts/dictionaryContext';
import { useLocale } from '@/hooks/useLocale';
import { usePathname } from 'next/navigation';
import React, { HTMLAttributes } from 'react';
import NavBreadcrumb from '../../NavBreadcrumb';

interface ICustomBreadcrumbProps extends HTMLAttributes<HTMLDivElement> {
  categoryTitle: string;
}

export const CustomBreadcrumb: React.FC<ICustomBreadcrumbProps> = ({
  categoryTitle,
}) => {
  const lang = useLocale();
  const { category: dict } = useTranslation();
  const pathname = usePathname();

  return (
    <NavBreadcrumb.Root>
      <NavBreadcrumb.Item path={lang === 'en' ? '/' : `/${lang}`}>
        {dict.breadcrumbHome}
      </NavBreadcrumb.Item>
      {/* <NavBreadcrumb.Item
      // path="/sicily/experiences/villas"
      >
        {dict.breadcrumbVillas}
      </NavBreadcrumb.Item> */}
      <NavBreadcrumb.Item
        path={pathname.substring(0, pathname.lastIndexOf('/'))}>
        {dict.breadcrumbExperiences}
      </NavBreadcrumb.Item>
      <NavBreadcrumb.Item>{categoryTitle}</NavBreadcrumb.Item>
    </NavBreadcrumb.Root>
  );
};
